import createAuth0Client from '@auth0/auth0-spa-js';
import history from '../utils/History';
import { store } from '../../redux/store';

class Auth0Service {
  static INSTANCE;

  static getInstance = () => {
    if (!Auth0Service.INSTANCE) {
      Auth0Service.INSTANCE = new Auth0Service();
    }
    return Auth0Service.INSTANCE;
  };

  constructor() {
    this.loading = false;
  }

  onRedirectCallback = appState => {
    history.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    );
  };

  init = async () => {
    let resolve = null;
    try {
      store.dispatch({
        type: 'UPDATE_AUTH0_LOADING',
        auth0loading: true,
      });

      const auth0Client = await createAuth0Client({
        domain: process.env.AUTH0_DOMAIN,
        client_id: process.env.AUTH0_CLIENT_ID,
        redirect_uri: window.location.origin,
      });

      this.auth0Client = auth0Client;

      if (window.location.search.includes('code=')) {
        const { appState } = await auth0Client.handleRedirectCallback();
        this.onRedirectCallback(appState);
      }

      const isAuthenticated = await auth0Client.isAuthenticated();
      this.isAuthenticated = isAuthenticated;

      if (isAuthenticated) {
        const user = await auth0Client.getUser();
        store.dispatch({
          type: 'UPDATE_AUTH0_USER',
          auth0user: user,
        });
      } else if (window.location.search.includes('error=')) {
        history.push('/error?wrongPlatform=true');
      } else {
        auth0Client.loginWithRedirect();
      }

      store.dispatch({
        type: 'UPDATE_AUTH0_LOADING',
        auth0loading: false,
      });

      resolve = Promise.resolve('done');
    } catch (error) {
      resolve = Promise.reject(error);
    }
    return resolve;
  };
}

export default Auth0Service;
